export default __webpack_public_path__ + "static/media/orange-arrow-circle.901e75ce.svg";